exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./reset.css"), "");

// module
exports.push([module.id, "body {\n  background-color: #f5f6f8;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/app/style/style.styl
// module id = 1349
// module chunks = 0